const AsciiMag = "        ______\n     .-'      `-.\n   .'            `.\n  /                \\\n ;                 ;`\n |                 |;\n ;                 ;|\n '\\               / ;\n  \\`.           .' /\n   `.`-._____.-' .'\n     / /`_____.-'\n    / / /\n   / / /\n  / / /\n / / /\n/ / /\n\\/_/";
export {
  AsciiMag as default
};
//# sourceMappingURL=magnifying.ascii.js.map
